/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportSampleRequestsV2MutationRequest,
  ExportSampleRequestsV2MutationResponse,
  ExportSampleRequestsV2400,
  ExportSampleRequestsV2500,
} from '../types/ExportSampleRequestsV2'

function getExportSampleRequestsV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/samples/sample-requests/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async sample requests export.
 * Request body:
 * {
 * "selected_columns": ["created", "status_display", "company_name"],
 * "export_type": "csv",
 * "filter_params": { ... },
 * "sort": "-created"
 * }
 * Returns 202:
 * {
 * "request_id": 123,
 * "status": "pending",
 * "progress_percentage": 0,
 * "item_count": 0
 * }
 * @summary Start an async sample requests export
 * {@link /api/v1/samples/sample-requests/export/v2/}
 */
export async function exportSampleRequestsV2(
  data: ExportSampleRequestsV2MutationRequest,
  config: Partial<RequestConfig<ExportSampleRequestsV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportSampleRequestsV2MutationResponse,
    ResponseErrorConfig<ExportSampleRequestsV2400 | ExportSampleRequestsV2500>,
    ExportSampleRequestsV2MutationRequest
  >({
    method: 'POST',
    url: getExportSampleRequestsV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
